import { Button, Modal, Select, Tag } from "antd";
import React, { useRef, useState } from "react";
import { dispatchtoast, getLocalStorageItem } from "../../../../Utils";
import {
  getPayoutAndDmtOtp,
  XpressPayoutOtp,
} from "../../../../ApiServices/Apifun";
import { CopyOutlined } from "@ant-design/icons";
import ReportDrawer from "../../../../Common/ReportDrawer";
import VerifyModal from "../../../../Common/VerifyModal";
import { Globalendpoints } from "../../../../ApiServices/global";

import { useSelector } from "react-redux";
import OtpExpressPayout from "./OtpEkoExpressPayout";
import OtpEkoExpressPayout from "./OtpEkoExpressPayout";
import { Images } from "../../../../Controller";
import { useReactToPrint } from "react-to-print";

const EkoXPayModal = ({
  isOpen,
  setIsOpen,
  details,
  beneficiaryId,
  transaction_type,
  mobile,
  remitterDetails,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [originalVal, setOriginalVal] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [openVerifyModal, setOpenVerifyModal] = useState(false);
  const [purpose, setPurpose] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [otpuid, setOtpUid] = useState(null);
  const [hide, setHide] = useState(false);
  const [response, setResponse] = useState({});
  console.log(mobile, "mobile num here");
  const handleOk = () => {
    setIsOpen(false);
  };
  const handleCancel = () => {
    setIsOpen(false);
  };

  const formatNumberWithCommas = (value) => {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleChange = (e) => {
    const sanitized = e.target.value.replace(/[^0-9.]/g, "");
    setOriginalVal(sanitized);
    const formattedValue = formatNumberWithCommas(sanitized);
    setInputValue(formattedValue);
  };
  const handlePay = () => {
    setOpenVerifyModal(true);

    // setBtnLoading(true);
    // XpressPayoutOtp()
    //   .then((res) => {
    //     if (res.status) {
    //       setOtpUid(res.otp_uid);
    //       setHide(true);
    //       setOpenVerifyModal(true);
    //     }
    //   })
    //   .catch((err) => console.log(err))
    //   .finally(() => setBtnLoading(false));
  };

  const printRef = useRef(null);
  const profiledetail = useSelector((state) => state.B2B.profileDetail);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });
  console.log(details, beneficiaryId, remitterDetails, response);

  // if (!data) return null;
  const Content = () => {
    return (
      <>
        <div className="border-2 rounded-md w-9/12 border-dashed border-gray-500  ml-4 mr-4 text-center mt-5">
          <p className="-mt-2 bg-white w-[100px] flex justify-center items-center font-semibold m-auto text-[11px]">
            Transaction I'd
          </p>
          <p className="text-[11px] mt-2 mb-2">qwdqwd</p>
        </div>
        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
          <div className="flex justify-between items-center">
            <p>Balance Amount</p>
            <p className="text-black">qwdwqd Rs.</p>
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      {!showSuccess ? (
        <Modal
          title={"Pay Amount"}
          footer={null}
          className={`shadow-normal ${hide ? "hidden" : ""}`}
          width={300}
          maskClosable={false}
          open={isOpen}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <>
            <div className="userDetail text-center font-semibold text-[13px]">
              <p>Paying {beneficiaryId?.beneficiary}</p>
              <p>{beneficiaryId?.account_id}</p>
              <p>Banking Name: {beneficiaryId?.beneficiary}</p>
            </div>
            {/* <div className="amount mt-4  font-bold text-center">
              <Select
                options={[
                  { label: "Saving Account", value: 2 },
                  { label: "Current Account", value: 1 },
                ]}
                placeholder="Select Wallet Type"
                // value={selectedAccountType}
                onChange={(e) => setSelectedAccountType(e)}
              />
            </div> */}
            <div className="amount mt-4  font-bold text-center">
              <p className="text-3xl">₹</p>
              <input
                onChange={(e) => handleChange(e)}
                value={inputValue}
                placeholder="0"
                className="border-none w-full text-lg text-center"
              />
            </div>
            <div className="mt-3">
              <select
                className="w-full border border-gray-300 rounded-lg  text-sm"
                value={purpose}
                onChange={(e) => setPurpose(e.target.value)}
              >
                <option value="">----Select Purpose of Payment----</option>
                <option value="Education Fees">Education Fees</option>
                <option value="Rent">Rent</option>
                <option value="Commission">Commission</option>
                <option value="Salary">Salary</option>
                <option value="Hospital">Hospital</option>
                <option value="Vendor Payment">Vendor Payment</option>
              </select>
            </div>
            <Button
              onClick={() => handlePay()}
              loading={btnLoading}
              disabled={!inputValue && !showSuccess}
              className="w-full mt-6 bg-primary hover:bg-primaryhover text-bswhite rounded-sm border-none"
            >
              Pay
            </Button>
          </>
        </Modal>
      ) : (
        <Modal
          title={"Transaction Receipt"}
          footer={null}
          closeIcon={false}
          className={`shadow-normal ${hide ? "hidden" : ""}`}
          width={800}
          maskClosable={false}
          open={isOpen}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          {/* PRINT AREA */}
          <div
            ref={printRef}
            className="bg-white text-[12px] border-2 border-blue-700 p-3"
          >
            {/* TOP SECTION */}
            <div className="flex justify-center items-center mb-2">
              <img src={Images?.WebsiteLogo} className="h-12" alt="Logo" />
            </div>
            <div className="flex justify-between">
              {/* LEFT */}
              <div className="space-y-1">
                <p>
                  <b>Shop Name :{profiledetail?.business_name}</b>
                </p>
                <p>
                  <b>Mobile No :{profiledetail?.mobile}</b>
                </p>
                <p>
                  <b>Sender Name :{remitterDetails[0]?.name}</b>
                </p>
                <p>
                  <b>Sender No :{remitterDetails[0]?.mobile}</b>
                </p>
              </div>

              {/* RIGHT */}
              <div className="space-y-1 text-right">
                <p>
                  <b>Beneficiary :</b> {beneficiaryId?.beneficiary}
                </p>
                <p>
                  <b>Bank Name :{beneficiaryId?.bank_name}</b>
                </p>
                <p>
                  <b>Account No :{beneficiaryId?.account_id}</b>
                </p>
                <p>
                  <b>Date :</b> {new Date().toLocaleString()}
                </p>
              </div>
            </div>

            {/* DIVIDER */}
            <div className="border-t-2 border-blue-700 my-2"></div>

            {/* TRANSACTION TABLE */}
            <table className="w-full text-center border-collapse">
              <thead>
                <tr className="border-b-2 border-blue-700">
                  <th className="p-1">TID</th>
                  <th className="p-1">MODE</th>
                  <th className="p-1">Status</th>
                  <th className="p-1">UTR No</th>
                  <th className="p-1 text-right">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="p-1">{response.transaction_id}</td>
                  <td className="p-1">{transaction_type}</td>
                  <td className="p-1">
                    {response.status === "1" ? (
                      <Tag color="green">Success</Tag>
                    ) : response.status === "2" ? (
                      <Tag color="red">Failed</Tag>
                    ) : (
                      <Tag color="yellow">Pending</Tag>
                    )}
                  </td>
                  <td className="p-1">{response.utr ?? "--"}</td>
                  <td className="p-1 text-right font-semibold">
                    ₹ {originalVal}
                  </td>
                </tr>
              </tbody>
            </table>

            {/* TOTAL */}
            <div className="flex justify-end border-t-2 border-blue-700 mt-2 pt-1">
              <p className="font-semibold">Total &nbsp; ₹ {originalVal}</p>
            </div>
          </div>

          {/* ACTIONS */}
          <div className="flex gap-2 mt-4">
            <Button className="w-full" onClick={() => setIsOpen(false)}>
              Close
            </Button>

            <Button className="w-full" onClick={handlePrint}>
              Print / Download
            </Button>
          </div>
        </Modal>
      )}

      {openVerifyModal && (
        <OtpEkoExpressPayout
          isOpen={openVerifyModal}
          setIsOpen={setOpenVerifyModal}
          setShowSuccess={setShowSuccess}
          setResponse={setResponse}
          setXpaymodal={setIsOpen}
          setHide={setHide}
          // account_type={selectedAccountType}
          otherFields={{
            // otp_uid: otpuid,
            latitude: getLocalStorageItem("latitude"),
            longitude: getLocalStorageItem("longitude"),
            amount: originalVal,
            purpose: purpose,
            transaction_type: transaction_type,
            mobile: mobile,
            ...beneficiaryId,
          }}
          // endpoint={Globalendpoints.payAmount}
        />
      )}
      {/* {openReceiptDrawer &&
      <ReportDrawer
        title={"Payout Receipt"}
        open={openReceiptDrawer}
        setOpen={setOpenReceiptDrawer}
        content={<Content />}
      />
} */}
    </>
  );
};

export default EkoXPayModal;
